import { ref } from "vue"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import BootstrapButton from "../form/BootstrapButton"
import SimpleForm from "../form/SimpleForm"

interface Props {
	totalPages: number

	cancel(): void
	select(page: number): void
}

const SelectPageForm: ReactiveComponent<Props> = (props) => {
	const page = ref<number | null>()

	return () => (
		<SimpleForm onSubmit={() => props.select(page.value!)}>
			<input
				autofocus
				class="w-full mb-3"
				placeholder="Enter page number..."
				type="number"
				v-model={page.value}
				min={1}
				max={props.totalPages}
				required
			/>
			<hr />
			<div class="flex justify-end">
				<div class="flex flex-wrap items-center spacing-3">
					<BootstrapButton color="secondary" type="button" onClick={props.cancel}>
						Cancel
					</BootstrapButton>
					<BootstrapButton color="primary" type="submit">
						Go
					</BootstrapButton>
				</div>
			</div>
		</SimpleForm>
	)
}

export default defineComponent(SelectPageForm, inferProps<Props>())
